import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(
  ) { }

  getStockId(type: any) {
    let res = null
    switch (type) {
      case 'deliberatedForMoreThan7Days':
        res = 4
        break;
      case 'approvedForLessThan7Days':
        res = 3
        break;
      case 'planningOrders':
        res = 2
        break;
      case 'suspendedOrders':
        res = 1
        break;
      case 'nonProgrammableOrders':
        res = 5
        break;
    }
    return res
  }

  getStockCode(id: any) {
    let res = null
    switch (id) {
      case 4:
        res = 'deliberatedForMoreThan7Days'
        break;
      case 3:
        res = 'approvedForLessThan7Days'
        break;
      case 2:
        res = 'planningOrders'
        break;
      case 1:
        res = 'suspendedOrders'
        break;
      case 5:
        res = 'nonProgrammableOrders'
        break;
    }
    return res
  }

}
